import { useEffect, useState } from 'react';

function useVisibilityTransition(isVisible: boolean) {
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsTransitioning(true);
    } else {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  return isTransitioning;
}

export default useVisibilityTransition;
